import styled from 'styled-components'
import { iPadDown } from '../../styles/mediaQueries'

export const CardIconWrapper = styled.div`
  align-items: center;
  border: 1px solid currentColor;
  border-radius: 0.48vw;
  display: flex;
  height: 1.88vw;
  justify-content: center;
  width: 2.97vw;

  ${iPadDown} {
    border-radius: 1.3vw;
    height: 5.35vw;
    width: 8.5vw;
  }

  svg {
    fill: currentColor;
  }

  .icon--visa-card {
    height: 0.7vw;
    width: auto;
    ${iPadDown} {
      height: 2.5vw;
    }
  }

  .icon--discover-card {
    height: 0.45vw;
    width: auto;
    ${iPadDown} {
      height: 1.4vw;
    }
  }

  .icon--mastercard,
  .icon--amex-card {
    > svg {
      height: 100%;
      width: auto;
    }
  }

  .icon--mastercard {
    display: flex;
    height: 0.8vw;

    ${iPadDown} {
      height: 3vw;
    }

    > svg {
      position: relative;

      &:first-child {
        left: 0.04vw;

        ${iPadDown} {
          left: 0.25vw;
        }
      }

      &:last-child {
        right: 0.04vw;

        ${iPadDown} {
          right: 0.25vw;
        }
      }
    }
  }

  .icon--amex-card {
    display: flex;
    height: 0.6vw;

    ${iPadDown} {
      height: 1.8vw;
    }
  }

  .icon--default-card {
    height: 1vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ${iPadDown} {
      height: 3.09vw;
    }

    > svg {
      height: 0.23vw;
      width: auto;

      ${iPadDown} {
        height: 0.72vw;
      }

      &:last-child {
        align-self: flex-end;
      }
    }
  }
`
